import { render, staticRenderFns } from "./SettingsLiquidations.vue?vue&type=template&id=0104b604"
import script from "./SettingsLiquidations.vue?vue&type=script&lang=js"
export * from "./SettingsLiquidations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports